
import React from 'react';

const sectors = [
  { icon: 'ri-plant-line', label: 'Row Crops', desc: 'Corn, soybeans, wheat' },
  { icon: 'ri-seedling-line', label: 'Grain Production', desc: 'Timely fungicide & nutrients' },
  { icon: 'ri-goblet-line', label: 'Vineyards & Orchards', desc: 'Precision canopy care' },
  { icon: 'ri-tree-line', label: 'Timber & Woodland', desc: 'Forestry management' },
  { icon: 'ri-home-4-line', label: 'Livestock & Pasture', desc: 'Grazing land stewardship' },
  { icon: 'ri-leaf-line', label: 'Specialty Crops', desc: 'High-value produce' },
  { icon: 'ri-earth-line', label: 'Conservation & CRP', desc: 'Cover crops & sustainability' },
  { icon: 'ri-landscape-line', label: 'Land Management', desc: 'Assessment & planning' },
];

export default function QuickOverview() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-14">
          <span className="inline-block text-emerald-700 font-bold text-xs tracking-widest uppercase mb-4">
            Sectors at a Glance
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            One Partner, Many Operations
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto font-light">
            Whether you manage thousands of acres or a family farm, we bring the same commitment to yield
            protection and practical results.
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {sectors.map((s, i) => (
            <div
              key={i}
              className="group bg-stone-50 hover:bg-emerald-50 rounded-lg p-5 border border-gray-100 hover:border-emerald-200 transition-all duration-300 cursor-pointer"
            >
              <div className="w-12 h-12 flex items-center justify-center bg-white rounded-lg mb-3 group-hover:bg-emerald-100 transition-colors shadow-sm">
                {/* Using a fallback for missing icon libraries */}
                <i className={`${s.icon} text-2xl text-emerald-700`} aria-hidden="true"></i>
              </div>
              <h3 className="font-bold text-gray-900 mb-1 text-sm">{s.label}</h3>
              <p className="text-xs text-gray-500">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
